import { Tag } from "@/Components/Tag";
import { MoreVertical } from "react-feather";
import { ActionMenu } from "@/Components/ActionMenu";
import React, { useRef, useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import { toast } from "react-toastify";
import { usePage } from "@inertiajs/inertia-react";
import { Dialog } from "@/Components";

const GlobalReporterUserRow = ({ user }) => {
  const currentUser = usePage().props.auth?.user?.data || {};

  const [isDeleting, setIsDeleting] = useState(false);

  const actionMenuItems = [
    // {
    //   label: "Edit user",
    //   callback: () => {
    //     // Inertia.visit(`/users/edit/${user.id}`
    //     console.log("Edit users not yet implemented");
    //   },
    // },
  ];

  if (currentUser.id !== user.id) {
    actionMenuItems.push({
      label: "Delete user",
      callback: () => setIsDeleting(true),
    });
  }

  const actionMenuRef = useRef(null);

  function handleDelete() {
    const id = toast.loading("Please wait...");

    Inertia.delete(route("agency.users.uninvite", user.id), {
      onSuccess: () => {
        toast.update(id, {
          render: `User was successfully removed`,
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });
      },
      onError: (error) => {
        toast.update(id, {
          render: `Something went wrong when removing user`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      },
    });
  }

  const displayName =
    user.firstname && user.surname ? user.fullname : user.email;

  return (
    <>
      <div className="shadow-small grid-rows-[repeat(2, auto)] mb-2 grid min-h-[53px] grid-cols-4 gap-2 bg-gray-light p-4 md:grid-flow-col-dense md:grid-cols-12 md:grid-rows-1 md:p-8 md:px-4 md:py-2">
        <div className="col-span-3 flex items-center md:col-span-4">
          <h3
            className={`truncate leading-none ${user.firstname && user.surname ? "font-bold" : ""}`}
          >
            {displayName}
          </h3>
        </div>
        <div className="col-span-4 flex items-center md:col-span-7">
          <div className="row-start-2 flex flex-wrap items-center gap-2 md:row-start-1">
            {!user.firstname || !user.surname ? (
              <Tag>Pending invitation</Tag>
            ) : user.teams && user.teams.length > 0 ? (
              user.teams.map((team, i) => <Tag key={i}>{team.name}</Tag>)
            ) : null}
          </div>
        </div>
        <div className="col-span-1 col-start-4 row-start-1 flex items-center justify-end md:col-start-12">
          <div className="hover-circle relative z-10 ml-2">
            <MoreVertical
              size={24}
              className="shrink-0 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                actionMenuRef.current.toggleMenu();
              }}
            />
            <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
          </div>
        </div>
      </div>

      {isDeleting && (
        <Dialog
          openModal={isDeleting}
          closeModal={() => setIsDeleting(false)}
          modalStyle="popup"
          animation="fade-in"
          title={`You're about to delete ${displayName} from your organization`}
          tag="Delete user"
          tagStyle="bg-[#FEE5E5]"
        >
          <p>
            This action is permanent and cannot be undone, are you sure you want
            to delete {displayName}?
          </p>

          <div className="flex w-full items-center justify-end">
            <a
              className="cursor-pointer text-blue underline"
              onClick={() => setIsDeleting(false)}
            >
              Cancel
            </a>

            <button
              className="btn-red ml-3 grow-0 self-end"
              onClick={handleDelete}
            >
              Delete user
            </button>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default GlobalReporterUserRow;
